import { useEffect, useState } from 'react';
import Navbar from '../../Navbar'
import moment from 'moment' // con esto manejamos las fechas bien
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Typography, Box, Grid, Card, IconButton, CardHeader, Avatar, Stack, Chip } from '@mui/material';
import CrearRepartos2 from './crearRepartos/CrearRepartos2';
import Verrepartos4 from './verRepartos/Verrepartos4';
import { getData } from '../../../services/library';
import { logEventos } from '../../../services/services';
import { ShoppingCart } from '@mui/icons-material';

export default function Repartos() {
  let fechahoy = moment(new Date()).format("DD-MM-YYYY");
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setsucursalSeleccionada] = useState(null)
  const [mostrarSucursales, setMostrarSucursales] = useState(true);
  const [openTabla, setOpenTabla] = useState(false);
  const [verReparto, setVerReparto] = useState(false);
  const [pedidosSucursales, setpedidosSucursales] = useState(true);
  const [obt, setObt] = useState(0);

  const noHayNadaParaMostrar = <>
    <Card>
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: "red" }}>R</Avatar>}
        title="No hay pedidos pendientes para asignar a una rendición"
        subheader={fechahoy}
      />
    </Card>
  </>

  const obtenerPedidosxSucursal = () => {
    getData('/sucursales/sucursalespedidos', setSucursales)
  };


  const abrirTabla = (id_sucursal) => {
    setsucursalSeleccionada(sucursales.filter((sucursal) => sucursal.id_sucursal === id_sucursal))
    setOpenTabla(true)
    setMostrarSucursales(false)
    setVerReparto(false)
  };

  useEffect(() => {
    obtenerPedidosxSucursal()
  }, [openTabla, obt]);

  const openVerRepartos = () => {
    setVerReparto(true)
    setOpenTabla(false)
    setMostrarSucursales(false)
    setpedidosSucursales(false)
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Repartos",
      "Granel",
      "lista Pedidos No Asignados por sucursal",
      localStorage.getItem("user"));
  }, []);

  return (
    <div style={{ position: "relative", width: '100%' }}>
      <Navbar />
      <br />
      {pedidosSucursales &&
        <>
          <Box sx={{ flexGrow: 1 }}>
            <Grid backgroundColor="#1F618D" p={2}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center">
              <Grid item xs={10} >
                <Typography variant="h5" color="#ffffff">
                  {openTabla && sucursalSeleccionada ? <span>Creando nueva rendición para sucursal {sucursalSeleccionada[0]?.nombre}</span> : <span>Pedidos No Asignados por sucursal</span>}
                </Typography>
              </Grid>
              <Grid item xs={0.5} >
                <IconButton onClick={() => openVerRepartos()} sx={{ border: 'white', color: "#ffffff" }} >
                  <LocalShippingIcon titleAccess='Ver Rendiciones ' />
                </IconButton>
              </Grid>
            </Grid>

          </Box>
          <br />
          <Grid container spacing={1} direction="row">
            {!openTabla && mostrarSucursales && sucursales ? sucursales.map(elemento =>
              <Grid item xs={6} sm={6} md={4} key={elemento.id_sucursal}>
                <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3, cursor: 'pointer', borderColor: elemento.color_id }}
                  onClick={() => {
                    if (parseInt(localStorage.getItem("sector")) !== 12) {
                      alert("No tiene permiso para realizar esta acción.")
                    } else { abrirTabla(elemento.id_sucursal); }
                  }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      sx={{
                        bgcolor: elemento.color_id,
                        width: 56,
                        height: 56,
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}
                    >
                      {elemento.avatar}
                    </Avatar>

                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                        {elemento.nombre}
                      </Typography>

                    </Box>

                    <Chip
                      label={`${elemento.cantidad_pedidos}`}
                      sx={{
                        bgcolor: '#e0f7fa',
                        color: '#00796b',
                        fontWeight: 'bold'
                      }}
                    />
                  </Stack>
                </Card>

              </Grid>) : null}
          </Grid>
          {openTabla ? <CrearRepartos2 sucursal={sucursalSeleccionada} setOpen={setOpenTabla} setMostrarSucursales={setMostrarSucursales} setVerReparto={setVerReparto} actualizar={obtenerPedidosxSucursal} /> : null}
          {Object.keys(sucursales).length === 0 ? <>{noHayNadaParaMostrar}</> : null}
          <br />
        </>
      }

      {verReparto ?
        <Verrepartos4 setOpen={setOpenTabla}
          setVerReparto={setVerReparto}
          setpedidosSucursales={setpedidosSucursales}
          setMostrarSucursales={setMostrarSucursales}
          actualizar={obtenerPedidosxSucursal}>
        </Verrepartos4> : null}

    </div>
  )

}
{/*<Card variant="outlined"
                  onClick={() => {
                    if (parseInt(localStorage.getItem("sector")) !== 12) {
                      alert("No tiene permiso para realizar esta acción.")

                    } else { abrirTabla(elemento.id_sucursal); }
                  }} style={{ backgroundColor: "#ffffe6", boxShadow: "1px 4px grey", cursor: 'pointer' }}>
                   <CardHeader
                    avatar={
                      <Stack>
                        <Avatar sx={{ bgcolor: elemento.color_id }} aria-label="recipe">
                          {elemento.avatar}
                        </Avatar>

                        <Avatar variant='rounded' sx={{ bgcolor: "teal", fontSize: "14px" }}>{elemento.cantidad_pedidos}</Avatar>
                      </Stack>
                    }
                    titleTypographyProps={{ variant: 'h5' }}
                    title={`${elemento.nombre}`}
                  // disabled={parseInt(localStorage.getItem("sector")) !== 12} 
                  /> 
                  
                </Card>*/}